import { render, staticRenderFns } from "./FullImg.vue?vue&type=template&id=2747b436&scoped=true"
var script = {}
import style0 from "./FullImg.vue?vue&type=style&index=0&id=2747b436&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2747b436",
  null
  
)

export default component.exports